import React from 'react';
import { Link } from 'react-router-dom';

export const Wordmark = ({ className = '' }) => (
  <Link to="/" className={`wordmark ${className}`} data-testid="nav-wordmark" aria-label="Ikarus Landed — home">
    <span className="wordmark-name">IKARUS</span>
    <span className="wordmark-sub">LANDED</span>
  </Link>
);
